export const Roles = [
    { label: 'Technicien', value: 2 },
    { label: 'Administrateur', value: 1 },
]



// WEBPACK FOOTER //
// ./src/config/enum/Roles.js